<template>
  <a :href="link" rel="noopener noreferrer" class="text-orange-500 underline">
    <slot />
  </a>
</template>

<script setup lang="ts">
import type { Inline } from '@contentful/rich-text-types'
import { computed } from 'vue'
import { EMAIL_REGEX_PATTERN, PHONE_REGEX_PATTERN } from '~/constants'
import { useCMSLink } from '~/modules/cms/providers/contentful/composables/useCMSLink'

const props = defineProps<{ node: Inline }>()

const inlineAttrs = computed(() => {
  let url = props.node.data.uri ?? ''
  if (/^https?:\/\//.test(url)) {
    // Do nothing, URL is fine
  } else if (EMAIL_REGEX_PATTERN.test(url)) {
    url = `mailto:${url}`
  } else if (PHONE_REGEX_PATTERN.test(url)) {
    url = `tel:${url}`
  }
  return { href: url }
})

const { parseURL } = useCMSLink()
const link = computed(() => parseURL(inlineAttrs.value.href).normalized)
</script>
